import { useContext, useEffect, useState } from "react";

import { DatabaseContext } from "./filrebase";

const useRooms = () => {
  const db = useContext(DatabaseContext);
  const [{ loading, data, error }, setState] = useState({
    data: null,
    loading: false,
    error: null
  });

  useEffect(() => {
    setState({ loading: true });
    return db.ref("/rooms").on(
      "value",
      data => {
        if (data) {
          setState({ loading: false, data: data.val(), error: null });
        }
      },
      error => {
        setState({ loading: false, data, error });
      }
    );
  }, []);

  return { data, loading, error };
};

const useRoom = roomId => {
  const db = useContext(DatabaseContext);
  const [{ loading, data, error }, setState] = useState({
    data: null,
    loading: false,
    error: null
  });
  useEffect(() => {
    setState({ loading: true });
    return db.ref(`/rooms/${roomId}`).on(
      "value",
      data => {
        if (data) {
          setState({ loading: false, data: data.val(), error: null });
        }
      },
      error => {
        setState({ loading: false, data, error });
      }
    );
  }, []);

  return { data, loading, error };
};

export { useRooms, useRoom };
